import * as Diagram from "../../../../components/diagram";

export const MedicationEligibleForHealthInsurance = {
  label: "符合健保用藥",
  key: "MedicationEligibleForHealthInsurance",
  path: "BoneMuscleCare/MedicationEligibleForHealthInsurance",
  api: "TCS_V_CanTransferListV",
  render: (options) => (
    <Diagram.BoneMuscleCare.MedicationEligibleForHealthInsurance {...options} />
  ),
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "鄉鎮", type: "string" },
  ],
  columns: [
    {
      key: "CaseID",
      field: "CaseID",
      header: "案件編號",
    },
    {
      key: "Name",
      field: "Name",
      header: "個案姓名",
    },
    {
      key: "PID",
      field: "PID",
      header: "身分證字號",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "篩檢日期",
      field: "篩檢日期",
      header: "篩檢日期",
    },
    {
      key: "T值",
      field: "T值",
      header: "T值",
    },
    {
      key: "骨折",
      field: "骨折",
      header: "骨折",
    },
    {
      key: "罹患類風溼性關節炎",
      field: "罹患類風溼性關節炎",
      header: "類風溼性關節炎",
    },
    {
      key: "連續服用類固醇超過三個月",
      field: "連續服用類固醇超過三個月",
      header: "類固醇",
    },
  ],
};
